module.exports = __webpack_public_path__ + "assets/img/85e6051ad40beb8c601d5dd4dd9d0964.png";